import type { StatisticsPeriod, TicketStatistics } from '@easyhelp/shared';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './client';

/** Chiave della query delle statistiche di un periodo. */
export const statisticsQueryKey = (period: StatisticsPeriod) => ['statistiche', period] as const;

/** `GET /statistiche?periodo=`: indicatori e distribuzioni dei ticket ricevuti nel periodo. */
export function fetchStatistics(period: StatisticsPeriod): Promise<TicketStatistics> {
  return apiRequest<TicketStatistics>(`/statistiche?periodo=${period}`);
}

/** Statistiche del periodo; cambiare periodo è una nuova query (le precedenti restano in cache). */
export function useStatistics(period: StatisticsPeriod) {
  return useQuery({ queryKey: statisticsQueryKey(period), queryFn: () => fetchStatistics(period) });
}
